import { Store } from 'vuex';
import { Getters, Context } from 'vuex-smart-module';
import CartSharedState from './state';
import CartStore from '../../store';
import CartState from '../../store/state';

export default class CartSharedGetters extends Getters<CartSharedState> {
  cart_store!: Context<typeof CartStore>;

  $init(store: Store<CartState>): void {
    this.cart_store = CartStore.context(store);
  }

  get products_in_cart() {
    return this.cart_store.state.carts_products;
  }

  get project_choosen() {
    return this.cart_store.state.project_choosen;
  }

  get cart_loading() {
    return this.cart_store.state.cart_loading;
  }
}
